import { type FC, useEffect } from 'react';

import { useToastState } from 'dibs-toaster/exports/useToastState';
import { ADD_TO_FAVORITES_ACTION } from 'dibs-buyer-item-favoriting/exports/constants';

import { useSbSharedFavoritesNudgeToast } from './useSbSharedFavoritesNudgeToast';
import { setFavoritesNudgeDisplayed } from '../helpers/setFavoritesNudgeDisplayed';

type Props = {
    userId: string;
    onStopWatch: () => void;
};

const SbSharedFavoritesNudgeToastWatcher: FC<Props> = ({ userId, onStopWatch }) => {
    const { lastToastAction } = useToastState();
    const { isVisible } = useSbSharedFavoritesNudgeToast({ userId, showNudge: true });

    useEffect(() => {
        const isAddToFavoritesToastShown = lastToastAction === ADD_TO_FAVORITES_ACTION;
        if (isAddToFavoritesToastShown || isVisible) {
            if (isAddToFavoritesToastShown) {
                setFavoritesNudgeDisplayed();
            }

            onStopWatch();
        }
    }, [lastToastAction, isVisible, onStopWatch]);

    return null;
};

export { SbSharedFavoritesNudgeToastWatcher };
